import { Box, Text, Icon, TransparentButton } from '@redriverpress/system'
import { driver } from 'driver.js'
import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import DriverStyle from './driverStyle'

export default function TourButton({ steps }) {
  const driverRef = useRef(null)
  const cleanUp = () => {
    if (driverRef.current) {
      driverRef.current.destroy()
    }
  }
  useEffect(() => {
    cleanUp()

    driverRef.current = driver({
      showProgress: true,
      animate: true,
      steps,
    })
    return () => {
      cleanUp()
    }
  }, [steps])

  return (
    <TransparentButton
      onClick={() => {
        if (driverRef.current) {
          driverRef.current.drive()
        }
      }}
      px={0}
    >
      <DriverStyle />
      <Box display='flex' alignItems='center'>
        <Icon icon='map-marked' pr={2} />
        <Text fontWeight={600} fontSize={0}>
          Guided Tour
        </Text>
      </Box>
    </TransparentButton>
  )
}

TourButton.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      element: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
        .isRequired,
      popover: PropTypes.object,
      disableActiveInteraction: PropTypes.bool,
      onDeselected: PropTypes.func,
      onHighlightStarted: PropTypes.func,
      onHighlighted: PropTypes.func,
    })
  ).isRequired,
}
